var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('r-header',{directives:[{name:"show",rawName:"v-show",value:(!_vm.$route.meta.hideHeader),expression:"!$route.meta.hideHeader"}]}),_c('router-view',{attrs:{"header":_vm.header}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }